import { CalculateCost } from '../contracts';
import axios from 'axios';
import { createAxiosConfig } from '../apiHelpers';
import LogCannon from '@ace-clublabs/log-cannon';
import { ICalculateCostRequest } from '@lib/types';
import { AxiosError, CancelToken } from 'axios';
import StatusCode from 'status-code-enum';
import { COST_CALCULATOR_CANCEL_MESSAGE } from '../../components/CostCalculatorProvider/CostCalculatorProvider';

export const CalculateCostApi =
  (endpoint: string): CalculateCost =>
  async (request: ICalculateCostRequest, cancelToken?: CancelToken) => {
    try {
      const config = { ...createAxiosConfig(endpoint), cancelToken };
      const response = await axios.post(endpoint, request, config);

      LogCannon.blast('Calculate Cost success');
      return Promise.resolve(response.data.data);
    } catch (e: any | AxiosError) {
      if (e.message === COST_CALCULATOR_CANCEL_MESSAGE) {
        return Promise.resolve({ status: 'cancel' });
      }

      const errorResponse = e?.response?.data?.error;
      LogCannon.blast('Calculate Cost error', errorResponse);
      return Promise.resolve({
        status: 'error',
        error: {
          code: e?.response?.status || StatusCode.ServerErrorInternal,
          message: 'Calculate cost failed',
          ...errorResponse,
        },
      });
    }
  };
